const trackSelectors = 'a, button';
let eventTimout;
let delay = 500; //Hover delay in ms

function sendGtmHoverEvent(el) {
    window.dataLayer.push({
        'event': 'elementHover',
        'hoverDuration': `${delay}ms`,
        'href': el.getAttribute('href'),
        'label': el.innerText,
        'tagName': el.tagName,
      });
}

addEventListener('DOMContentLoaded', (event) => {
    //Wait for js created content, ex: cookie popup
    setTimeout(function() {
        //Add mouseenter and mouseleave event for all selectors
        document.querySelectorAll(trackSelectors)
            .forEach(element => {
                element.addEventListener('mouseenter', function(el) {
                    //Only push to GTM if user hover's more than ${delay}ms
                    eventTimout = setTimeout(function(){ sendGtmHoverEvent(el.target); }, delay);
                }, { passive: true });
                
                element.addEventListener('mouseleave', function(){
                    clearTimeout(eventTimout);
                }, { passive: true });  
            });
    }, 1000)
});
